import React from "react";

function Book() {
    return (
        <main className="book">
            <section className="section-01">
                <div className="wrapper">
                    <div className="content">
                        <img src={require("../assets/images/logo.png")} className="ikigai-logo" width="192" alt="logo" />
                        <p className="tagline">Your <span>Journey</span> to Feeling <span>Alive</span> <br /> and <span>Fulfilled
                            Everyday</span></p>
                        <img src={require("../assets/images/book/4.png")} className="book" alt="Book cover" />
                    </div>
                </div>
            </section>
            <section className="section-02">
                <div className="wrapper">
                    <h2 className="heading">Are you ready to meet the hero within you?</h2>
                    <p className="text reveal-type" data-bg-color="#B1B1B1" data-fg-color="black">This is Ikigai365 invites you
                        to whole-heartedly embrace daily life’s roller-coaster on your own journey of ‘making life worth
                        living everyday’. It includes stories & tools that inspire you to discover what uniquely makes you ‘feel alive & fulfilled’.  As you move through these pages, you may find that the hero you seek quietly
                        emerges from within your own everyday moments.</p>
                </div>
            </section>
            <section className="section-03">
                <div className="wrapper">
                    <div className="frame">
                        <img src={require("../assets/images/book/6.jpg")} className="image" alt="frame" />
                        <img src={require("../assets/images/book/7.jpg")} className="image" alt="frame" />
                        <img src={require("../assets/images/book/8.jpg")} className="image" alt="frame" />
                    </div>
                    <div className="content">
                        <div className="_left">
                            <p className="text">Through deeply personal stories of real Japanese people from their 20s all the
                                way to centenarians, <span>This is Ikigai365</span> aims to transport you to Japan and feel
                                like you are meeting all our inspiring real-life heroes from all walks of life and
                                experience a full spectrum of their life stories ranging from <span>‘Net Worth ≠ Self
                                    Worth’</span> to <span>‘Creating My Own Ibasho - A Place to Belong’</span> or
                                <span>‘Rewire Don’t Retire’</span> to <span>‘Curiosity is Ageless’</span>. We are publishing
                                this book to help you feel inspired to take baby steps forward on your own personal Ikigai
                                journeys. Our sincere hope is that over time we can all collectively evolve from the current
                                state of <span>‘human doings’</span> to truly become <span>‘human beings’</span>.
                            </p>
                            <a href="https://www.penguin.sg/book/this-is-ikigai365" target="_blank" rel="noopener noreferrer" className="btn"><span className="material-icons-outlined">settings_accessibility</span>Start
                                Feeling Alive</a>
                            <div className="inner-frame">
                                <img src={require("../assets/images/book/12.jpg")} className="image" alt="frame" />
                                <img src={require("../assets/images/book/11.jpg")} className="image" alt="frame" />
                            </div>
                        </div>
                        <div className="_right">
                            <img src={require("../assets/images/book/9.jpg")} className="image" alt="frame" />
                            <img src={require("../assets/images/book/10.jpg")} className="image" alt="frame" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-04">
                <div className="wrapper">
                    <div className="content">
                        <h4 className="heading">Praise for<span>This is Ikigai365</span></h4>
                    </div>
                    <div className="quote">
                        <h4 className="heading">A Blessing from His Holiness the Dalai Lama</h4>
                        <p className="text">‘I understand that Ikigai is about finding a meaningful life with warm heartedness.’
                        </p>
                        <p className="text">— His Holiness The Dalai Lama</p>
                    </div>
                </div>
            </section>
            <section className="section-05">
                <div className="wrapper">
                    <div className="_left">
                        <article className="quote">
                            <img src={require("../assets/images/book/15.png")} className="icon" alt="icon" />
                            <div className="description">
                                <p className="text">‘Our research has shown that strong social networks are just as vital to
                                    longevity as diet or exercise. This book beautifully captures how human connection and a
                                    sense of purpose-Ikigai-can nourish us across a lifetime.’</p>
                            </div>
                            <div className="author">Dr. Makoto Suzuki, M.D., Ph.D, <span>Co-author, The Okinawa Program and The
                                Okinawa Diet Plan</span></div>
                        </article>
                        <article className="quote">
                            <img src={require("../assets/images/book/15.png")} className="icon" alt="icon" />
                            <div className="description">
                                <p className="text">‘Ikigai365 is a refreshing and heartfelt reminder to slow down and reconnect
                                    with what really matters. Through powerful stories and practical tools, it helps you
                                    reflect on your life in a way that feels personal, hopeful, and actionable. This book
                                    doesn’t just talk about purpose—it helps you live it, one day at a time.’</p>
                            </div>
                            <div className="author">Dr. Marshall Goldsmith, <span>Thinkers50 #1 Executive Coach and New York
                                Times bestselling author of The Earned Life, Triggers, and What Got You Here Won’t Get
                                You There.</span></div>
                        </article>
                        <article className="quote">
                            <img src={require("../assets/images/book/15.png")} className="icon" alt="icon" />
                            <div className="description">
                                <p className="text">‘A graceful, grounded guide to living with meaning. This Is Ikigai365 weaves
                                    timeless insight with heartfelt stories—quietly powerful, deeply personal, and
                                    beautifully practical.’</p>
                            </div>
                            <div className="author">Dandapani, <span>Hindu priest, former monk, global speaker, and author of
                                The Power of Unwavering Focus</span></div>
                        </article>
                        <article className="quote">
                            <img src={require("../assets/images/book/15.png")} className="icon" alt="icon" />
                            <div className="description">
                                <p className="text">‘The people in this book are just living their everyday lives.  But their
                                    stories, the ways they live, are inspirational! From now on, I want to learn to love
                                    every moment of my life.’</p>
                            </div>
                            <div className="author">Yew Chong Yip, <span>Mural Artist</span></div>
                        </article>
                    </div>
                    <div className="_right">
                        <article className="quote">
                            <img src={require("../assets/images/book/15.png")} className="icon" alt="icon" />
                            <div className="description">
                                <p className="text">‘This book is a wonderful exposition of the fact that ikigai is a
                                    celebration of each person’s unique personality. It is inspiring to hear so many
                                    different voices, until we are immersed in the deeply resonant music of the orches’tra
                                    that is life.’</p>
                            </div>
                            <div className="author">Ken Mogi, <span>Japanese Scientist, Author – The Little Book of
                                Ikigai</span></div>
                        </article>
                        <article className="quote">
                            <img src={require("../assets/images/book/15.png")} className="icon" alt="icon" />
                            <div className="description">
                                <p className="text">‘This book reinforces the same message my lengthy research does: In the
                                    second phase of life, we must NOT start to wind down in retirement; rather, we must
                                    “rewire”.</p>
                                <p className="text">By “rewiring”, we reawaken our purpose, and we explore new ways of feeling
                                    alive and useful, no matter our age or circumstance.</p>
                                <p className="text">This book shares real-life stories of individuals in Japan who are quietly
                                    and powerfully living their Ikigai, through thoughtful introspection, emotional renewal
                                    and the pursuit of a life lived with meaning.</p>
                                <p className="text">I encourage you to read it, absorb its message, and enjoy it!’</p>
                            </div>
                            <div className="author">Dr. Riley Moynes, <span>TEDx Speaker, Author – The Four Phases of
                                Retirement</span></div>
                        </article>
                        <article className="quote">
                            <img src={require("../assets/images/book/15.png")} className="icon" alt="icon" />
                            <div className="description">
                                <p className="text">‘Through the wisdom of the 23 individuals in this book, you will find your
                                    reasons to wake up each morning. If you want to have a meaningful life, read this book.’
                                </p>
                            </div>
                            <div className="author">Eric Sim, <span>Author – Small Actions</span></div>
                        </article>
                        <article className="quote">
                            <img src={require("../assets/images/book/15.png")} className="icon" alt="icon" />
                            <div className="description">
                                <p className="text">‘I have known Rajiv for several years and he is a genuine practitioner and
                                    explorer of Ikigai and has instilled these principles in his own life as well as lives
                                    of thousands of others.</p>
                                <p className="text">This book is a true result of the years of deep research that he has done in
                                    the subject and has the potential of transforming every life.</p>
                                <p className="text">I recommend this book to everyone.’</p>
                            </div>
                            <div className="author">Ira Trivedi, <span>Yoga Acharya, Bestselling Author</span></div>
                        </article>
                    </div>
                </div>
            </section>

        </main>

    );
}

export default Book;

